var SCM = SCM || {};

SCM.GiftAccessModals = (function ($) {

    var _config = {
        createLinkEndpoint: '/Toolbox/CreateGiftLink',
        getRemainingEndpoint: '/Toolbox/GetRemainingGiftLinks',
        copyFeedbackDuration: 2000
    };

    var _state = {
        resourceId: null,
        resourceType: null,
        resourceUrl: null
    };

    var _selectors = {
        modalB: '#giftAccessModalB',
        modalC: '#giftAccessModalC',
        captchaStep: '.js-gift-access-captcha-step',
        successStep: '.js-gift-access-success-step',
        errorMessage: '.js-gift-access-form .js-error-message',
        createButton: '.js-create-gift-link',
        copyButton: '.js-copy-gift-link',
        linkText: '.js-gift-link-text',
        remainingCount: '.js-gift-articles-count',
        formContainer: '.js-gift-access-form',
        copyText: '.js-copy-text',
        copiedText: '.js-copied-text',
        giftAccessButton: '.gift-article-access',
        signInButton: '.js-gift-access-signin'
    };

    function init() {
        if ($(_selectors.giftAccessButton).length === 0) {
            return;
        }

        wireEventHandlers();
    }

    function wireEventHandlers() {
        $(_selectors.giftAccessButton).on('click', handleGiftAccessButtonClick);
    }

    function wireModalEventHandlers() {
        $(_selectors.createButton).off('click.giftAccess').on('click.giftAccess', handleCreateGiftLinkClick);
        $(_selectors.copyButton).off('click.giftAccess').on('click.giftAccess', handleCopyClick);
    }

    function handleGiftAccessButtonClick(e) {
        e.preventDefault();

        var $panelButton = $(_selectors.giftAccessButton + '[data-is-user-logged-on]').first();

        _state.resourceId = $panelButton.data('resource-id');
        _state.resourceType = $panelButton.data('resource-type');
        _state.resourceUrl = $panelButton.data('resource-url') || window.location.pathname;

        var isUserLoggedOn = $panelButton.data('is-user-logged-on') === true;
        var isIndividualAccount = $panelButton.data('is-individual-account') === true;

        if (!isUserLoggedOn || !isIndividualAccount) {
            openModalA();
        } else {
            checkRemainingAndOpenModal();
        }
    }

    function handleSignInClick(e) {
        if ($(this).hasClass('js-sign-in-link')) {
            return;
        }
        e.preventDefault();
        var returnUrl = window.location.pathname + window.location.search;
        window.location.href = '/sign-in?returnUrl=' + encodeURIComponent(returnUrl);
    }

    function handleCreateGiftLinkClick(e) {
        var $btn = $(this);
        var $form = $(_selectors.formContainer);
        var originalText = $btn.text();

        hideError();
        $btn.prop('disabled', true).text('Creating...');

        var captchaResponse = SCM.Captcha.GetCaptchaResponse($form);

        var requestData = {
            resourceId: _state.resourceId,
            resourceType: _state.resourceType,
            resourceUrl: _state.resourceUrl,
            captchaResponse: captchaResponse
        };

        SCM.Ajax.post(_config.createLinkEndpoint, requestData)
            .expectJson()
            .then(function(response) {
                if (response.success) {
                    showSuccess(response.giftUrl, response.remainingLinks);
                    pushGiftAccessLinkGeneratedEvent(response);
                } else {
                    showError(response.error || 'Failed to create gift link. Please try again.');
                    if (response.remainingLinks !== undefined) {
                        $(_selectors.remainingCount).text(response.remainingLinks);
                    }
                    SCM.Captcha.ResetCaptcha($form);
                }
            })
            .catch(function() {
                showError('An error occurred. Please try again.');
                SCM.Captcha.ResetCaptcha($form);
            })
            .finally(function() {
                $btn.prop('disabled', false).text(originalText);
            });
    }

    function handleCopyClick(e) {
        e.preventDefault();
        e.stopPropagation();
        var $btn = $(this);
        var giftLinkText = $(_selectors.modalB + ' ' + _selectors.linkText).first().text();
        performCopy($btn, giftLinkText, _config.copyFeedbackDuration);
    }

    function performCopy($btn, text, duration) {
        $btn.prop('disabled', true);

        SCM.copyToClipboard(text).then(function() {
            $btn.find(_selectors.copyText).addClass('hide');
            $btn.find(_selectors.copiedText).removeClass('hide');

            SCM.wait(duration).then(function() {
                $btn.find(_selectors.copyText).removeClass('hide');
                $btn.find(_selectors.copiedText).addClass('hide');
                $btn.prop('disabled', false);
            });
        }).catch(function() {
            $btn.prop('disabled', false);
        });
    }

    function checkForPostSignInModalOpen() {
        if (sessionStorage.getItem('openGiftAccessModalAfterSignIn') !== 'true') {
            return;
        }

        sessionStorage.removeItem('openGiftAccessModalAfterSignIn');

        var $panelButton = $(_selectors.giftAccessButton + '[data-is-user-logged-on]').first();

        if ($panelButton.length === 0) {
            return;
        }

        var isUserLoggedOn = $panelButton.data('is-user-logged-on') === true;
        var isIndividualAccount = $panelButton.data('is-individual-account') === true;

        if (!isUserLoggedOn || !isIndividualAccount) {
            return;
        }

        _state.resourceId = $panelButton.data('resource-id');
        _state.resourceType = $panelButton.data('resource-type');
        _state.resourceUrl = $panelButton.data('resource-url') || window.location.pathname;

        checkRemainingAndOpenModal();
    }

    function openModalA() {
        var $modalContent = $('#giftAccessModalA');
        sessionStorage.setItem('openGiftAccessModalAfterSignIn', 'true');
        SCM.Modals.showModal($modalContent);
        getModalContainer().find(_selectors.signInButton).on('click', handleSignInClick);
    }

    function openModalB() {
        var $modalContent = $(_selectors.modalB);

        resetModalState();
        SCM.Modals.showModal($modalContent);
        wireModalEventHandlers();
        fetchAndDisplayRemainingCount();
        loadRecaptcha();
    }

    function loadRecaptcha() {
        var $container = $(_selectors.modalB).find('.js-gift-recaptcha-container');
        if ($container.length && !$container.data('recaptcha-loaded')) {
            $container.data('recaptcha-loaded', true);
            $.get('/ThirdParty/ReCaptcha?controlId=gift-access-modal', function (html) {
                $container.html(html);
            });
        }
    }

    function openModalC() {
        var $modalContent = $(_selectors.modalC);
        SCM.Modals.showModal($modalContent);
    }

    function checkRemainingAndOpenModal() {
        SCM.Ajax.get(_config.getRemainingEndpoint)
            .expectJson()
            .then(function(response) {
                if (response.remainingLinks <= 0) {
                    openModalC();
                } else {
                    openModalB();
                }
            });
    }

    function fetchAndDisplayRemainingCount() {
        SCM.Ajax.get(_config.getRemainingEndpoint)
            .expectJson()
            .then(function(response) {
                $(_selectors.remainingCount).text(response.remainingLinks);
            })
            .catch(function() {
                $(_selectors.remainingCount).text('--');
            });
    }

    function getModalContainer() {
        return $('#globalModalContent');
    }


    function showSuccess(giftUrl, remaining) {
        var $modal = getModalContainer();
        $modal.find(_selectors.captchaStep).addClass('hide');
        $modal.find(_selectors.successStep).removeClass('hide');

        $modal.find(_selectors.linkText).first().text(giftUrl);
        $modal.find(_selectors.remainingCount).text(remaining);

        $modal.find(_selectors.copyButton).focus();
    }

    function showError(message) {
        getModalContainer().find(_selectors.errorMessage).text(message).removeClass('hide');
    }

    function hideError() {
        getModalContainer().find(_selectors.errorMessage).text('').addClass('hide');
    }

    function resetModalState() {
        var $modal = $(_selectors.modalB);
        $modal.find(_selectors.captchaStep).removeClass('hide');
        $modal.find(_selectors.successStep).addClass('hide');
        $modal.find(_selectors.errorMessage).text('').addClass('hide');

        $modal.find(_selectors.linkText).first().text('');
        $modal.find(_selectors.copyText).removeClass('hide');
        $modal.find(_selectors.copiedText).addClass('hide');
    }

    function pushGiftAccessLinkGeneratedEvent(response) {
        if (typeof window.dataLayer === 'undefined') {
            return;
        }

        window.dataLayer.push({
            event: 'gift_access_link_generated',
            article_id: _state.resourceId ? _state.resourceId.toString() : 'unknown',
            journal_id: extractJournalId(),
            access_key: extractAccessKeyFromUrl(response.giftUrl),
            link_url: response.giftUrl,
            timestamp: new Date().toISOString()
        });
    }

    function extractJournalId() {
        var $metaJournalId = $('meta[name="journal-id"]');
        if ($metaJournalId.length) {
            return $metaJournalId.attr('content');
        }

        var $dataJournalId = $('[data-journal-id]').first();
        if ($dataJournalId.length) {
            return $dataJournalId.data('journal-id').toString();
        }

        var $metaSiteName = $('meta[property="og:site_name"]');
        if ($metaSiteName.length) {
            return $metaSiteName.attr('content');
        }

        return 'unknown';
    }

    function extractAccessKeyFromUrl(url) {
        if (!url) {
            return '';
        }
        var match = url.match(/guestAccessKey=([^&]+)/);
        return match ? match[1] : '';
    }

    return {
        init: init,
        openModalA: openModalA,
        openModalB: openModalB,
        openModalC: openModalC,
        checkForPostSignInModalOpen: checkForPostSignInModalOpen
    };

})(jQuery);
